/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-04 11:13:25
 * @LastEditors: jikeychang@gmail.com
 * @LastEditTime: 2021-03-04 11:14:22
 * @Description: FileDescription
 */

import db from './db';

const model = {
  /**
   * 预算部门
   */
  // 获取:预算部门树
  getBudgetDepartmentList(param) {
    return db.post('/sys/dept/listDept', param);
  },
  // 详情:预算部门树
  dtlBudgetDepartment(id) {
    return db.get(`/sys/dept/${id}`);
    // return db.get('/sys/dept', id);
  },
  // 删除:预算部门树
  delBudgetDepartment(param) {
    return db.post('/sys/dept/remove', param);
  },
  // 新增:预算部门树
  addBudgetDepartment(param) {
    return db.post('/sys/dept/create', param);
  },
  // 编辑:预算部门树
  editBudgetDepartment(param) {
    return db.post('/sys/dept/modify', param);
  },
  // 获取:user
  getUserList(param) {
    return db.post('/sys/user/getListByUsernameLike', param);
  },
  // 获取：usersTree
  getUsersTree(param) {
    return db.get('/sys/dept/listDepts', param);
  },
  // 获取：usersTreeChild
  getUsersTreeChild(param) {
    return db.get('/sys/dept/listChildUsersDepts', param);
  },
};

export default model;
